import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TranslocoService } from '@ngneat/transloco';
import { Compbaser } from '../../../../components/compbaser';
import { ITableListColumn } from '../../../../components/table-list-input/table-list-input.component';
import { Id } from '../../../../interfaces';
import { StoreSelectorsService } from '../../../../services';
import { actionUpdateScripts } from '../../../../store/actions/user.actions';
import { IButtonBar } from '../../../../components/add-remove-bar/button-bar.component';
import * as _ from 'lodash';
import {Lib} from "../../../../../libs/Lib";

@Component({
    selector: 'app-block-scripts',
    templateUrl: './block-scripts.component.html',
    styleUrls: ['./block-scripts.component.scss']
})
export class BlockScriptsComponent extends Compbaser implements OnInit  {

    group: FormGroup;

    selectedSceneId: Id;
    tableButtons: IButtonBar[] = [];
    tableColumns: Array<ITableListColumn> = [];

    scripts: Array<any> = [];

    @Input()
    set setSelectedSceneId(i_setSelectedSceneId: Id) {
        this.selectedSceneId = i_setSelectedSceneId;
    }

    constructor(
        private translocoService: TranslocoService,
        public storeSelector: StoreSelectorsService,
        private fb: FormBuilder,

    ) {
        super();

        this.tableButtons = [
            {
                callBack: v => (v),
                icon: 'add',
                name: 'add',
                disableByList: false,
                disabled: false,
            },
            {
                callBack: v => (v),
                icon: 'remove',
                name: 'remove',
                confirmRemove: this.translocoService.translate('toast.deleteConfirm', {}, this.translocoService.getActiveLang()),
                disableByList: true,
                disabled: false,
            },
        ];
        this.tableColumns = [
            {
                inputType: 'edit',
                name: 'url',
                maxStringSize: '15'
            },
            {
                inputType: 'edit',
                name: 'className',
                maxStringSize: '8'
            },
            {
                inputType: 'edit',
                name: 'params',
                maxStringSize: '10'
            }
        ];
    }

    ngOnInit(): void {
        this.group = this.fb.group({
            scriptTableControl: []
        });

        this.cod(this.storeSelector.listenSceneData(this.selectedSceneId)
            .subscribe((i_sceneData) => {
                if (i_sceneData.Player.Scripts) {
                    this.scripts = i_sceneData.Player.Scripts[0].Script;
                }
                if (!this.scripts) this.scripts = [];

                this.group.get('scriptTableControl').setValue(this.scripts);
            })
        );
    }

    onCallBackValue() {
        return (item, direction) => {
            switch (direction) {
                case 'IN': {
                    item.$ = {
                        url: item.$?.url,
                        className: item.$?.className,
                        params: item.$?.params
                    };
                    return item;
                }
                case 'OUT': {
                    // item = {
                    //     Script: item
                    // };
                    // delete item.$;
                    return item;
                }
            }
        };
    }

    onTableUpdate(e) {
        switch (e.currentAction) {
            case 'added': {
                const data = _.cloneDeep(this.scripts);
                data.push({
                    $: {
                        url: "url...",
                        className: "class...",
                        params: "params..."
                    }
                });
                this.storeSelector.dispatch(actionUpdateScripts({
                    sceneId: this.selectedSceneId,
                    data: data
                }));
                break;
            }
            case "rename": {
                this.storeSelector.dispatch(actionUpdateScripts({
                    sceneId: this.selectedSceneId,
                    data: e.values
                }));
                break;
            }
            case 'removed': {
                if (!e.selected || !e.selected[0]) {
                    return;
                }
                this.storeSelector.dispatch(actionUpdateScripts({
                    sceneId: this.selectedSceneId,
                    data: e.values
                }));
                break;
            }
        }
    }
}
